import { render, staticRenderFns } from "./ItemBtnNextEstagio.vue?vue&type=template&id=126b2164"
import script from "./ItemBtnNextEstagio.vue?vue&type=script&lang=js"
export * from "./ItemBtnNextEstagio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports